module.exports = __webpack_public_path__ + "static/media/chargeDetails.7c13fd51.png";